import type { Action } from 'react-sweet-state';
import { createStore, createHook, createActionsHook } from 'react-sweet-state';

interface ActionMenuOpenState {
	isOpen: boolean;
}

const initialState: ActionMenuOpenState = {
	isOpen: false,
};

const actions = {
	setIsOpen:
		(isOpen: boolean): Action<ActionMenuOpenState> =>
		({ setState }) => {
			setState({ isOpen });
		},
};

export const store = createStore({
	initialState,
	actions,
	name: 'ActionMenuOpenStore',
});

export const useOpenActionMenuState = createHook(store);
export const useOpenActionMenuActions = createActionsHook(store);
